export const configExtras = {
    GOOGLE_CLIENT_ID:
      "781747190459-7lo9rki62sfi0kuc0p5ot3ctl7belr2o.apps.googleusercontent.com",
    FACEBOOK_APP_ID: "2490344927869658",
    INTERCOM_APP_ID: "mi73h8ob",
  };
  

  